export enum ChatGroupingType {
  Regular,
  SMS,
  SMSUnmatched
}